module.exports = __webpack_public_path__ + "static/2008-layer-3-920a5e61ee1220f764f2aa5ecd021b03.png";